import { YesNo } from "../../pages/general-company-information/types";
import { Attorney, AttorneyValues } from "../../pages/power-of-attorney/types";
import { LanguageBackendType } from "../../pages/shared/components/language/types";
import {
  LanguageChosenEvent,
  SameOrOtherEvent,
  YesNoDecisionEvent,
} from "./types";

export const mapLanguageToEvent = (
  language: LanguageBackendType,
): LanguageChosenEvent => {
  switch (language) {
    case LanguageBackendType.GERMAN:
      return LanguageChosenEvent.German;
    case LanguageBackendType.FRENCH:
      return LanguageChosenEvent.French;
    case LanguageBackendType.ITALIAN:
      return LanguageChosenEvent.Italian;
    case LanguageBackendType.ENGLISH:
      return LanguageChosenEvent.English;
    default:
      return null;
  }
};

export const mapYesNoDecisionToEvent = (
  decision: YesNo,
): YesNoDecisionEvent => {
  return decision === YesNo.YES
    ? YesNoDecisionEvent.Yes
    : YesNoDecisionEvent.No;
};

export const mapPersonSameAsToEvent = (isSame: boolean): SameOrOtherEvent => {
  return isSame ? SameOrOtherEvent.Identical : SameOrOtherEvent.Other;
};

export const mapAttorneyTypeToEvent = (
  attorneyType: Attorney,
): SameOrOtherEvent => {
  return attorneyType === AttorneyValues.NONE
    ? SameOrOtherEvent.None
    : mapPersonSameAsToEvent(attorneyType === AttorneyValues.ADMIN);
};
